import React, { useMemo } from 'react'
import { usePaletteTheme } from '../context/paletteTheme'
import { useSection } from '../context/section'
import { useGraphContext } from '../context/graphContext'
import { CameraAlt } from '@mui/icons-material'
import Tooltip from './Tooltip'
import { graphOptions, timeRangeGraphOptions,mainGraphLineColors } from '../utils/constants'
import LineGraph from './Graphs/LineGraph'
import { getInitialBrushRange, decorateLayers } from './Graphs/graphUtils'
import { toPng } from 'html-to-image'
import { IconButton, Skeleton, Typography } from '@mui/material'
import { downloadFile } from '../utils/tools'
import Select from './ui/SelectWithExternalLabel'


export default function SampleGraph({graphId}) {
    const { datasetLabels } = useSection()
    const { graphFig, handleGraphFunction } = useGraphContext()
    const { colors } = usePaletteTheme()

    const { fig, displayMethod, timeRange, timeFrame } = graphFig

    const layers = useMemo(() => fig && decorateLayers(mainGraphLineColors,fig, datasetLabels), [fig, datasetLabels])
    const initialRange = useMemo(() => layers && getInitialBrushRange(layers, timeFrame), [layers, timeFrame])   

    const changeFunction = (data) => {
        const optionSelected = data.value
        handleGraphFunction({...graphFig, displayMethod: optionSelected, timeRange: optionSelected === 'RC' ? timeRange : 'ALL'})
    }

    const changeTimeRange = (data) => handleGraphFunction({...graphFig, timeRange: data.value})
    
    const downloadGraphAsPng = async () => {
        const graph = document.getElementById(graphId)
        const uri = await toPng(graph, {backgroundColor: colors.dark1})
        downloadFile(uri, `FE-graph`)
    }

    return (
        <>
            <div className='graph' value={graphId}>
                <div className="graph__header">
                    <div className="graph__header-right">
                        <div>
                            <div>
                                <Typography>Display method:</Typography>
                                <Select elevation={3} setValue={changeFunction} value={displayMethod} options={graphOptions}/>
                            </div>
                            {displayMethod === 'RC' &&  <div>
                                    <Typography>Baseline:</Typography>
                                    <Select elevation={3} setValue={changeTimeRange} value={timeRange} options={timeRangeGraphOptions}/>
                                </div>
                            }
                        </div>
                        <Tooltip title="Download Graph as a PNG">
                            <IconButton onClick={downloadGraphAsPng}><CameraAlt color='textSecondary' className='btn-icon'/></IconButton>
                        </Tooltip>
                    </div>
                </div>
                { layers && initialRange ? <LineGraph initialRange={initialRange} layers={layers} graphId={graphId}/> : <Skeleton width='100%' height='500px'/> }
            </div>
        </>
    )
}
